import { useTranslate } from "src/i18n";

export const usePlatformsBlockTranslate = () => {
  const { t } = useTranslate();

  const title = t(
    "outsourcing.platforms_block.title",
    "Поддерживаемые платформы",
  );

  const description = t(
    "outsourcing.platforms_block.description",
    "WooCommerce и InSales: два мощных решения для электронной коммерции",
  );

  const woocommerce = t(
    "outsourcing.platforms_block.woocommerce_text",
    "WooCommerce — это гибкий и масштабируемый плагин для WordPress, который позволяет создавать интернет-магазины любой сложности. С открытым исходным кодом и множеством расширений, он идеально подходит для тех, кто хочет полный контроль над своим сайтом и его функциональностью.",
  );

  const insales = t(
    "outsourcing.platforms_block.insales_text",
    "InSales — это облачная платформа для создания интернет-магазинов с готовыми инструментами для управления товарами, заказами и маркетингом. Она предлагает простоту настройки и встроенные решения для SEO, аналитики и интеграции с популярными сервисами, что делает её отличным выбором для быстрого старта бизнеса.",
  );

  return { title, description, woocommerce, insales };
};
